import { containerFactory } from 'app/infrastructure/redux/index';
import { footerTranslation } from './constants';
import { FooterProps } from './types';
import { routeConstants, routeName } from 'app/routes/route-constants';
import { Footer } from './components/footer/footer';

const routesWithNoFooterLinks = [
  routeConstants.userProfileMainView,
  `${routeConstants.userProfileMainView}/`
];

const routesWithNoFooter = [
  `/${routeName.Draft}/`,
  `/${routeName.Case}/`,
  routeConstants.bowtie,
  routeConstants.indicatorFactorsAdministration,
  routeConstants.importMappings
];

const selector = {
  shouldRenderLinks: (_: any, props: any) => !routesWithNoFooterLinks.some(r => props.location.pathname?.indexOf(r) > -1),
  showFooter: (_: any, props: any) => !props.fetching && !routesWithNoFooter.some(r => props.location.pathname?.indexOf(r) > -1)
};

const container = containerFactory<FooterProps>(Footer, undefined, selector, footerTranslation) as any;

export { container as Footer };
